import { createFileRoute } from '@tanstack/react-router'
import { useIntlayer, useLocale } from 'react-intlayer'
import Body from '@/components/body'
import Heading from '@/components/heading'
import englishText from '@/components/md/en/term_of_service.md?raw'
import japaneseText from '@/components/md/ja/term_of_service.md?raw'
import ReactMarkdown from '@/components/react-markdown'

export const Route = createFileRoute('/term/eula/')({
  component: Page
})

function Page() {
  const content = useIntlayer('app')
  const { locale } = useLocale()
  return (
    <>
      <Heading>
        <Heading.Title>{content.label.term_of_service}</Heading.Title>
      </Heading>
      <Body className='max-w-3xl mx-auto'>
        <ReactMarkdown>{locale === 'en' ? englishText : japaneseText}</ReactMarkdown>
      </Body>
    </>
  )
}
